import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export var getThemePreferences = function getThemePreferences(themeState) {
  var colorMode = themeState.colorMode,
    dark = themeState.dark,
    light = themeState.light,
    shape = themeState.shape,
    spacing = themeState.spacing,
    typography = themeState.typography;
  var themePreferences = colorMode === 'auto' ? [light, dark] : [themeState[colorMode]];
  [shape, spacing, typography].forEach(function (themeId) {
    if (themeId) {
      themePreferences.push(themeId);
    }
  });
  if (getBooleanFF('platform.design-system-team.border-checkbox_nyoiu')) {
    themePreferences.push("".concat(themePreferences.includes('dark') ? 'dark' : 'light', "-new-input-border"));
  }

  // Load spacing by default
  if (!themePreferences.includes('spacing')) {
    themePreferences.push('spacing');
  }
  return _toConsumableArray(new Set(themePreferences));
};